import { Injectable } from '@angular/core';
import { InfoService } from './info.service';
import { StorageHelper } from './helpers/StorageHelper';
import { Global } from './classes/Global';

@Injectable()
export class GlobalService {

  newCardDeal: boolean = false;
  lastCardDealId: number = 0;

  listeners: IGlobalServiceListener[] = [];

  constructor(
    private infoService: InfoService
  ) { }

  subscribe(listener: IGlobalServiceListener) {
    this.listeners.push(listener);
    this.notify();
  }

  unsubscribe(listener: IGlobalServiceListener) {
    const index = this.listeners.indexOf(listener);
    this.listeners.splice(index, 1);
  }

  getLastCardDealId() {
    this.infoService.getLastCardDealId(Global.getCountry()).subscribe(res => {
      this.lastCardDealId = res["id"];
      if(this.lastCardDealId) {
        this.newCardDeal = this.lastCardDealId > StorageHelper.getInstance().get(StorageHelper.keys.lastCardDealId);
        StorageHelper.getInstance().save(StorageHelper.keys.lastCardDealId, this.lastCardDealId);
        this.notify();
      }
    }, err => {
  
    });
  }

  hasNewCardDeal(): boolean {
    return this.newCardDeal;
  }

  updateNewCardDeal(value: boolean) {
    this.newCardDeal = value;
    this.notify();
  }

  notify() {
    this.listeners.forEach(l => {
      l.newCardDealChange(this.newCardDeal);
    });
  }

}

export interface IGlobalServiceListener {
  newCardDealChange(value: boolean);
}
